import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { Component } from '../component';
import { curry } from '../utils/func';
import { popoverClass } from '../Popover/styles';
import { buttonClass } from '../Button/styles';
import { inputClass } from '../Input/styles';
import { inputBorderClass } from '../Form/styles';
import Popover from '../Popover';
import { isRTL } from '../config';
import getDataset from '../utils/dom/getDataset';
export default curry(function (options, Origin) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(_class, _Component);

    var _super = _createSuper2(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.el = void 0;
      _this.el = null;
      _this.state = {
        focus: props.autoFocus
      };
      _this.bindRef = _this.bindRef.bind(_assertThisInitialized(_this));
      _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
      _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this)); // this.enterPress = this.enterPress.bind(this)

      return _this;
    }

    _createClass(_class, [{
      key: "bindRef",
      value: function bindRef(el) {
        this.el = el;
      }
    }, {
      key: "handleBlur",
      value: function handleBlur(event) {
        this.setState({
          focus: false
        });
        var onBlur = this.props.onBlur;
        if (onBlur) onBlur(event);
      }
    }, {
      key: "handleFocus",
      value: function handleFocus(event) {
        this.setState({
          focus: true
        });
        var onFocus = this.props.onFocus;
        if (onFocus) onFocus(event);
      }
    }, {
      key: "renderHelp",
      value: function renderHelp(focus) {
        var _this2 = this;

        var _this$props = this.props,
            error = _this$props.error,
            tip = _this$props.tip,
            popover = _this$props.popover,
            _this$props$popoverPr = _this$props.popoverProps,
            popoverProps = _this$props$popoverPr === void 0 ? {} : _this$props$popoverPr;
        var classList = ['input-tip'];
        var position = popover || (isRTL() ? 'bottom-right' : 'bottom-left');
        var styles = popoverProps.style && popoverProps.style.width ? popoverProps.style : Object.assign({
          minWidth: 200,
          maxWidth: 400
        }, popoverProps.style || {}); // 只有有错需要popover，或者tip被focus才显示

        if (error && popover || tip && focus) {
          if (error) classList.push('input-error');
          return (
            /*#__PURE__*/
            React.createElement(Popover, Object.assign({
              getPopupContainer: function getPopupContainer() {
                return _this2.el;
              }
            }, popoverProps, {
              visible: true,
              style: styles,
              className: popoverClass.apply(void 0, classList),
              position: position
            }), error ? error.message : tip)
          );
        }

        return null;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            className = _this$props2.className,
            border = _this$props2.border,
            size = _this$props2.size,
            tip = _this$props2.tip,
            popover = _this$props2.popover,
            width = _this$props2.width,
            style = _this$props2.style,
            error = _this$props2.error,
            popoverProps = _this$props2.popoverProps,
            underline = _this$props2.underline,
            other = _objectWithoutProperties(_this$props2, ["className", "border", "size", "tip", "popover", "width", "style", "error", "popoverProps", "underline"]);

        var focus = this.state.focus;
        var rtl = isRTL();
        var Tag = options.tag || 'label';
        var newStyle = Object.assign({
          width: width
        }, style);
        var isDisabled = typeof other.disabled === 'function' ? false : !!other.disabled;
        var newClassName = classnames(inputBorderClass(rtl && 'rtl'), inputClass('_', rtl && 'rtl', focus && !isDisabled && 'focus', isDisabled && 'disabled', options.isGroup && 'group', size, newStyle.width && 'inline', !border && 'no-border', options.overflow && "overflow-".concat(options.overflow), error && 'invalid', popover && error && 'focus', underline && 'underline'), buttonClass(options.isGroup && 'group', options.from === 'input' && options.isGroup && 'from-input-group'), typeof options.className === 'function' ? options.className(this.props) : options.className, this.props.className);
        return (
          /*#__PURE__*/
          React.createElement(Tag, Object.assign({
            ref: this.bindRef,
            className: newClassName,
            style: newStyle,
            tabIndex: options.enterPress ? 0 : undefined
          }, getDataset(other)),
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, other, {
            size: size,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            inputFocus: focus
          })), this.renderHelp(focus))
        );
      }
    }]);

    return _class;
  }(Component), _class.defaultProps = {
    border: true,
    style: {},
    popoverProps: {}
  }, _temp;
});